export const ALLOWED_IMAGE_TYPES = ['image/png', 'image/jpeg', 'image/webp'];
export const MAX_FILE_SIZE = 250 * 1024 * 1024; // 250 MB

export const parseJsonFile = (file: File): Promise<unknown> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      try {
        resolve(JSON.parse(reader.result as string));
      } catch (e) {
        reject(
          new Error(`Failed to parse ${file.name}: ${(e as Error).message}`),
        );
      }
    };
    reader.onerror = () => reject(new Error(`Failed to read ${file.name}`));
    reader.readAsText(file);
  });
};

export const validateImageFile = (file: File): string | null => {
  if (!ALLOWED_IMAGE_TYPES.includes(file.type))
    return 'Invalid type! Use PNG, JPG, or WEBP.';
  if (file.size > MAX_FILE_SIZE) return 'File too large (max 100 MB)';
  return null;
};

export const formatFileSize = (file: File): string => {
  return `${file.name} (${(file.size / (1024 * 1024)).toFixed(2)} MB)`;
};

export const getImageNaturalDimensions = (
  file: File,
): Promise<{ width: number; height: number }> => {
  return new Promise((resolve, reject) => {
    const url = URL.createObjectURL(file);
    const img = new Image();
    img.onload = () => {
      resolve({ width: img.naturalWidth, height: img.naturalHeight });
      URL.revokeObjectURL(url);
    };
    img.onerror = () => {
      reject(new Error('Could not read dimensions'));
      URL.revokeObjectURL(url);
    };
    img.src = url;
  });
};
